<template>
    <div id="app">
        <el-container>
            <el-header>
                <div class="header-content">
                    <h1>行李寄存自助估价系统</h1>
                    <p>客服唯一联系方式 微信：hszt214</p>
                </div>
            </el-header>

            <!-- 新增导航菜单 -->
            <div class="nav-menu">
                <el-menu mode="horizontal" :default-active="activeMenu" @select="handleMenuSelect">
                    <el-menu-item index="priceRules">收费标准</el-menu-item>
                    <el-menu-item index="calculator">自助估价</el-menu-item>
                    <el-menu-item index="contact">联系方式</el-menu-item>
                </el-menu>
            </div>

            <el-main>
                <el-card class="price-rules" id="priceRules">
                    <div slot="header">
                        <span>收费标准</span>
                    </div>
                    <div class="img" style="display: flex; flex-direction: column;">
                        <img src="./assets/收费标准.jpg" alt="收费标准">
                        <div class="discount-info">
                            <p>限30件以内，超过30件的部分另外算</p>
                        </div>
                        <img src="./assets/行李尺寸划分标准.jpg" alt="收费标准">
                    </div>

                </el-card>

                <el-card class="calculator" id="calculator">
                    <div slot="header">
                        <span>自助估价</span>
                    </div>
                    <el-form :model="form" label-width="90px">
                        <div v-for="(item, index) in form.items" :key="index" class="luggage-item">
                            <div class="item-header">
                                <span>行李类型 {{ index + 1 }}</span>
                                <el-button type="text" @click="removeItem(index)"
                                    v-if="form.items.length > 1">删除</el-button>
                            </div>

                            <el-form-item label="行李类型">
                                <el-select v-model="item.type" placeholder="请选择行李类型">
                                    <el-option label="纸箱" value="box"></el-option>
                                    <el-option label="塑料箱" value="sbox"></el-option>
                                    <el-option label="行李袋" value="bag"></el-option>
                                    <el-option label="行李箱" value="suitcase"></el-option>
                                    <el-option label="编织袋/蛇皮袋" value="snakeBag"></el-option>
                                    <el-option label="物流袋" value="logisticsBag"></el-option>
                                </el-select>
                            </el-form-item>

                            <template v-if="item.type != 'suitcase'">
                                <el-form-item label="长度(cm)">
                                    <el-input-number v-model="item.length" :min="1"></el-input-number>
                                </el-form-item>

                                <el-form-item label="宽度(cm)">
                                    <el-input-number v-model="item.width" :min="1"></el-input-number>
                                </el-form-item>

                                <el-form-item label="高度(cm)">
                                    <el-input-number v-model="item.height" :min="1"></el-input-number>
                                </el-form-item>
                            </template>

                            <el-form-item v-if="item.type === 'suitcase'" label="行李箱尺寸">
                                <el-select v-model="item.suitcaseSize" placeholder="请选择行李箱尺寸" style="width: 170px;">
                                    <el-option label="20寸及以下" value="20寸及以下"></el-option>
                                    <el-option label="22寸" value="22寸"></el-option>
                                    <el-option label="24寸" value="24寸"></el-option>
                                    <el-option label="26寸" value="26寸"></el-option>
                                    <el-option label="28寸及以上" value="28寸及以上"></el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="数量">
                                <el-input-number v-model="item.quantity" :min="1"
                                    style="width: 170px;"></el-input-number>
                            </el-form-item>
                        </div>

                        <el-form-item>
                            <el-button type="primary" @click="addItem">添加行李类型</el-button>
                        </el-form-item>

                        <el-form-item label="开始日期">
                            <el-date-picker v-model="form.startDate" type="date" placeholder="选择开始日期"
                                value-format="yyyy-MM-dd" :picker-options="{
                                    disabledDate(time) {
                                        return time.getTime() < Date.now() - 8.64e7;
                                    }
                                }" style="width: 100%;">
                            </el-date-picker>
                        </el-form-item>

                        <el-form-item label="结束日期">
                            <el-date-picker v-model="form.endDate" type="date" placeholder="选择结束日期"
                                value-format="yyyy-MM-dd" :picker-options="{
                                    disabledDate(time) {
                                        return time.getTime() < (form.startDate ? new Date(form.startDate).getTime() : Date.now() - 8.64e7);
                                    }
                                }" style="width: 100%;">
                            </el-date-picker>
                        </el-form-item>

                        <el-form-item label="我是应届生">
                            <el-switch v-model="form.isGraduate"></el-switch>
                        </el-form-item>

                        <el-form-item>
                            <el-button type="primary" @click="calculatePrice">计算价格</el-button>
                        </el-form-item>
                    </el-form>

                    <div v-if="dayTotalPrice" class="price-result">
                        <h3 style="color: #409EFF; border-bottom: 2px solid #409EFF; padding-bottom: 8px;">📅 方案一：按天计算</h3>
                        <p><strong>寄存天数：</strong>{{ days }}天</p>
                        <p><strong>单价：</strong>{{ dayPrice }}元/天</p>
                        <p v-if="monthDiscount"><strong>满月优惠：</strong>-{{ monthDiscount }}元（满30天享8折）</p>
                        <p v-if="graduateDiscount"><strong>应届生优惠：</strong>-{{ graduateDiscount }}元（额外9折）</p>
                        <p v-if="isShow2" style="color: #E6A23C;"><strong>最低消费：</strong>不足20元按20元计算</p>
                        <p v-if="isShow" style="color: #E6A23C;"><strong>封顶说明：</strong>一个月内优惠后总费用300元封顶</p>
                        <p class="total" style="margin-top: 15px; padding: 10px; background-color: #f0f9ff; border-radius: 5px;">
                            💰 最终价格：<span style="background-color: hsla(55, 89%, 50%, 0.903);font-size:23px; padding: 5px 15px; border-radius: 3px;">{{ dayTotalPrice }}元</span>
                        </p>
                        
                        <h3 style="color: #F56C6C; border-bottom: 2px solid #F56C6C; padding-bottom: 8px; margin-top: 25px;">📆 方案二：按月一口价</h3>
                        <p><strong>计费月数：</strong>{{ months }}个月（不足一月按一月计算）</p>
                        
                        <p><strong>月单价：</strong>{{ monthPrice }}元/月</p>
                        <p v-if="isShow3" style="color: #E6A23C;"><strong>封顶说明：</strong>月费用300元封顶</p>
                        <p class="total" style="margin-top: 15px; padding: 10px; background-color: #fef0f0; border-radius: 5px;">
                            💰 最终价格：<span style="background-color: hsla(55, 89%, 50%, 0.903);font-size:23px; padding: 5px 15px; border-radius: 3px;">{{ monthTotalPrice }}元</span>
                        </p>
                        
                        <div style="margin-top: 20px; padding: 10px; background-color: #fdf6ec; border-radius: 5px; border-left: 4px solid #E6A23C;">
                            <p style="margin: 5px 0; color: #E6A23C; font-weight: bold;">💡 温馨提示：</p>
                            <p style="margin: 5px 0; font-size: 13px; color: #666;">• 以上两种方案可任选其一</p>
                            <p style="margin: 5px 0; font-size: 13px; color: #666;">• 只有选择按天算，提前取行李才会退多余费用</p>
                        </div>
                        
                        <el-button type="success" @click="exportQuotation('user')"
                            style="margin-top: 20px;">导出报价单（给客服）</el-button>
                        <!-- <div></div>
                        <el-button type="success" @click="exportQuotation('admin')"
                            style="margin-top: 15px;">导出报价单（自用）</el-button> -->
                    </div>
                </el-card>

                <el-card class="contact" id="contact">
                    <div slot="header">
                        <span>联系方式</span>
                    </div>
                    <p>微信：hszt214</p>
                    <p>说明：自助估价后能接受的话请直接微信联系我</p>
                </el-card>
            </el-main>
        </el-container>

        <!-- 添加预览弹窗 -->
        <el-dialog title="报价单预览-长按图片可保存（电脑上右键点击可复制或保存图片）" :visible.sync="showPreview" width="90%"
            :close-on-click-modal="false" custom-class="preview-dialog">
            <div class="preview-container">
                <img :src="previewImage" alt="报价单预览" style="width: 100%;">
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showPreview = false">关闭</el-button>
                <div style="height: 10px;"></div>
                <el-button type="primary" @click="showPreview = false">我知道了</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import html2canvas from 'html2canvas';

export default {
    name: 'App',
    data() {
        const today = new Date();
        const nextMonth = new Date(today);
        nextMonth.setMonth(today.getMonth() + 1);

        return {
            activeMenu: 'priceRules',
            priceRules: [
                { type: '行李箱', size: '22寸及以上', price: '2' },
                { type: '行李箱', size: '22寸以下', price: '1' },
                { type: '纸箱/塑料箱/行李袋/物流袋/编织袋', size: '长宽高任意一边 >= 60cm', price: '2' },
                { type: '纸箱/塑料箱/行李袋/物流袋/编织袋', size: '长宽高均不超过60cm', price: '1' },
                { type: '纸箱/塑料箱/行李袋/物流袋/编织袋', size: '长宽高任意一边 > 100cm', price: '3' },

            ],
            form: {
                items: [{
                    type: '',
                    length: 60,
                    width: 40,
                    height: 50,
                    suitcaseSize: '',
                    quantity: 1,
                    size: '',   //记录是大件还是小件
                }],
                startDate: new Date().toISOString().split('T')[0],
                endDate: '',
                isGraduate: false
            },
            basePrice: 0,
            monthDiscount: 0,
            graduateDiscount: 0,
            dayPrice: 0,
            dayTotalPrice: 0,
            monthPrice: 0,
            monthTotalPrice: 0,
            months: 0,
            days: 0,
            showPreview: false,
            previewImage: '',
            isShow: false, //是否显示月内封顶300的优惠
            isShow2: false, //是否显示不足20的算20
            isShow3: false, //是否显示一口价封顶300元
        }
    },
    computed: {
        // isWechatBrowser() {
        //     const ua = navigator.userAgent.toLowerCase();
        //     return ua.indexOf('micromessenger') !== -1;
        // }
    },
    methods: {
        handleMenuSelect(index) {
            this.activeMenu = index;
            const element = document.getElementById(index);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        },
        addItem() {
            this.form.items.push({
                type: '',
                length: 60,
                width: 40,
                height: 50,
                suitcaseSize: '',
                quantity: 1
            });
        },
        removeItem(index) {
            this.form.items.splice(index, 1);
        },
        calculatePrice() {
            if (!this.form.startDate || !this.form.endDate) {
                this.$message.warning('请选择寄存时间');
                return;
            }

            if (this.form.items.some(item => !item.type)) {
                this.$message.warning('请选择所有行李类型');
                return;
            }

            if (this.form.items.some(item => {
                if ((item.type != 'suitcase') && (!item.length || !item.width || !item.height)) {
                    return true;
                }
                if (item.type === 'suitcase' && !item.suitcaseSize) {
                    return true;
                }
                return false;
            })) {
                this.$message.warning('请填写完整尺寸信息');
                return;
            }

            // 新增：总数量不能超过30件
            const totalCount = this.form.items.reduce((sum, item) => sum + item.quantity, 0);
            if (totalCount > 30) {
                this.$alert('总数量不能超过30件，请分两次计算。', '数量超限', {
                    confirmButtonText: '我知道了'
                });
                return;
            }

            const startDate = new Date(this.form.startDate);
            const endDate = new Date(this.form.endDate);
            this.days = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));
            // 计算月数，不足一个月的按一个月算
            this.months = Math.ceil(this.days / 30);

            this.basePrice = 0;
            this.monthDiscount = 0;
            this.graduateDiscount = 0;
            this.dayPrice = 0;
            this.dayTotalPrice = 0;
            this.monthPrice = 0;//按月算单价，不足一个月的按一个月算
            this.monthTotalPrice = 0;
            // 按月算单价：小件20元每件每月，大件25元每件每月，特大件50元每件每月
            // 计算每个行李类型的单价，生成所有件的单价数组
            let perDayArr = [];
            this.form.items.forEach(item => {
                let pricePerDay = 0;
                let maxDimension = 0;
                switch (item.type) {
                    case 'box':
                    case 'sbox':
                    case 'bag':
                    case 'snakeBag':
                    case 'logisticsBag':
                        maxDimension = Math.max(item.length, item.width, item.height);
                        if (maxDimension > 100) {
                            pricePerDay = 3;
                            item.size = '特大件,3r/天';
                            this.monthPrice += 50 * item.quantity;
                        } else if (maxDimension >= 60) {
                            pricePerDay = 2;
                            item.size = '大件,2r/天';
                            this.monthPrice += 25 * item.quantity;
                        } else {
                            pricePerDay = 1;
                            item.size = '小件,1r/天';
                            this.monthPrice += 20 * item.quantity;
                        }
                        break;
                    case 'suitcase':
                        switch (item.suitcaseSize) {
                            case '20寸及以下':
                                pricePerDay = 1;
                                item.size = '小件,1r/天';
                                this.monthPrice += 20 * item.quantity;
                                break;
                            case '22寸':
                            case '24寸':
                            case '26寸':
                            case '28寸及以上':
                                pricePerDay = 2;
                                item.size = '大件,2r/天';
                                this.monthPrice += 25 * item.quantity;
                                break;
                        }
                        break;

                }
                for (let i = 0; i < item.quantity; i++) {
                    perDayArr.push(pricePerDay);
                }
                this.basePrice += pricePerDay * this.days * item.quantity;
            });
            // 按单价从高到低排序，优先把贵的算进封顶
            perDayArr.sort((a, b) => b - a);
            // 计算每天的总单价（最多30件）
            this.dayPrice = perDayArr.slice(0, 30).reduce((sum, v) => sum + v, 0);
            
            // 计算按天算总价
            this.isShow = false;
            this.isShow2 = false;
            let total = 0;
            if (this.days <= 30) {
                total = this.dayPrice * this.days;
                // 如果刚好一个月
                if (this.days === 30) {
                    total *= 0.8;
                }
                //  如果是应届生
                if (this.form.isGraduate) total *= 0.9;
                if (total > 300) {
                    total = 300;
                    this.isShow = true;
                }
            } else {
                //  超过30天，计算月数和剩余天数
                let months = Math.floor(this.days / 30);
                let restDays = this.days % 30;

                // 先算一个月的费用
                let first30 = this.dayPrice * 30 * 0.8;
                // 如果是应届生
                if (this.form.isGraduate) first30 *= 0.9;
                if (first30 > 300) {
                    first30 = 300;
                    this.isShow = true;
                }
                total = first30 * months; //所有整月数的费用

                // 计算零散天数的费用
                let restPrice = this.dayPrice * restDays * 0.8;
                // 如果是应届生
                if (this.form.isGraduate) restPrice *= 0.9;
                if (restPrice > 300) restPrice = 300;
                total += restPrice;
            }

            this.dayTotalPrice = Number(total.toFixed(2));
            // 最低20元
            if (this.dayTotalPrice < 20) {
                this.dayTotalPrice = 20;
                this.isShow2 = true;
            }
            // 计算基础价、优惠金额（用于展示）
            if (this.days >= 30) {
                this.monthDiscount = Number((this.basePrice * 0.2).toFixed(2));
            } else {
                this.monthDiscount = 0;
            }
            if (this.form.isGraduate) {
                let afterMonth = this.basePrice - this.monthDiscount;
                this.graduateDiscount = Number((afterMonth * 0.1).toFixed(2));
            } else {
                this.graduateDiscount = 0;
            }
            
            // 计算按月算总价，一个月的费用超过300元，则取300元
            if (this.monthPrice > 300){
                this.monthPrice = 300;
                this.isShow3 = true;
            }else {
                this.isShow3 = false;
            }
            this.monthTotalPrice = Number((this.monthPrice * this.months).toFixed(2));
        },
        exportQuotation(user_identity) {
            if (!this.dayTotalPrice && !this.monthTotalPrice) {
                this.$message.warning('请先计算价格');
                return;
            }

            // 创建报价单内容
            const quotationContent = document.createElement('div');
            quotationContent.style.padding = '20px';
            quotationContent.style.backgroundColor = 'white';
            quotationContent.style.width = '600px';
            quotationContent.style.fontFamily = 'Microsoft YaHei, Arial, sans-serif';

            // 添加标题
            if (user_identity === 'user') {
                const title = document.createElement('h2');
                title.textContent = '行李寄存报价单';
                title.style.textAlign = 'center';
                title.style.color = '#409EFF';
                title.style.marginBottom = '20px';
                quotationContent.appendChild(title);
            }

            // 添加时间信息
            const timeInfo = document.createElement('div');
            timeInfo.innerHTML = `
                <p style="margin: 10px 0;"><strong>寄存时间：</strong>${this.form.startDate} 至 ${this.form.endDate}</p>
                <p style="margin: 10px 0;"><strong>寄存天数：</strong>${this.days}天</p>
            `;
            quotationContent.appendChild(timeInfo);

            // 添加行李清单
            const luggageList = document.createElement('div');
            luggageList.innerHTML = '<h3 style="margin: 15px 0; color: #409EFF; border-bottom: 2px solid #409EFF; padding-bottom: 5px;">行李清单：</h3>';
            this.form.items.forEach((item, index) => {
                let itemDesc = '';
                switch (item.type) {
                    case 'box':
                        itemDesc = `纸箱 (${item.length}*${item.width}*${item.height}cm)`;
                        break;
                    case 'sbox':
                        itemDesc = `塑料箱 (${item.length}*${item.width}*${item.height}cm)`;
                        break;
                    case 'bag':
                        itemDesc = `行李袋 (${item.length}*${item.width}*${item.height}cm)`;
                        break;
                    case 'suitcase':
                        itemDesc = `行李箱 (${item.suitcaseSize})`;
                        break;
                    case 'snakeBag':
                        itemDesc = `编织袋/蛇皮袋 (${item.length}*${item.width}*${item.height}cm)`;
                        break;
                    case 'logisticsBag':
                        itemDesc = `物流袋 (${item.length}*${item.width}*${item.height}cm)`;
                        break;
                }
                luggageList.innerHTML += `<p style="margin: 8px 0; padding-left: 10px;">${index + 1}. ${itemDesc} × ${item.quantity}件 <span style="color: #67C23A;">(${item.size})</span></p>`;
            });
            quotationContent.appendChild(luggageList);

            // 第一部分：按天算
            const dayPriceSection = document.createElement('div');
            dayPriceSection.style.marginTop = '20px';
            dayPriceSection.style.padding = '15px';
            dayPriceSection.style.backgroundColor = '#f0f9ff';
            dayPriceSection.style.borderRadius = '8px';
            dayPriceSection.style.border = '2px solid #409EFF';
            
            let dayPriceDetail = `
                <h3 style="margin: 0 0 10px 0; color: #409EFF; font-size: 18px;">📅 方案一：按天计算</h3>
                <p style="margin: 8px 0;"><strong>单价：</strong>${this.dayPrice}元/天</p>
            `;
            
            if (this.days >= 30) {
                dayPriceDetail += `<p style="margin: 8px 0;"><strong>满月优惠：</strong>满30天享8折优惠</p>`;
            }
            
            if (this.form.isGraduate) {
                dayPriceDetail += `<p style="margin: 8px 0;"><strong>应届生优惠：</strong>额外享9折优惠</p>`;
            }
            
            if (this.isShow) {
                dayPriceDetail += `<p style="margin: 8px 0; color: #E6A23C;"><strong>封顶说明：</strong>一个月内优惠后总费用300元封顶</p>`;
            }
            
            if (this.isShow2) {
                dayPriceDetail += `<p style="margin: 8px 0; color: #E6A23C;"><strong>最低消费：</strong>不足20元按20元计算</p>`;
            }
            
            dayPriceDetail += `
                <p style="margin: 15px 0 5px 0; font-size: 22px; font-weight: bold; color: #409EFF; text-align: center; padding: 10px; background-color: white; border-radius: 5px;">
                    💰 最终价格：<span style="background-color: hsla(55, 89%, 50%, 0.903); padding: 5px 15px; border-radius: 3px;">${this.dayTotalPrice}元</span>
                </p>
            `;
            
            dayPriceSection.innerHTML = dayPriceDetail;
            quotationContent.appendChild(dayPriceSection);

            // 第二部分：按月一口价
            const monthPriceSection = document.createElement('div');
            monthPriceSection.style.marginTop = '20px';
            monthPriceSection.style.padding = '15px';
            monthPriceSection.style.backgroundColor = '#fef0f0';
            monthPriceSection.style.borderRadius = '8px';
            monthPriceSection.style.border = '2px solid #F56C6C';
            
            let monthPriceDetail = `
                <h3 style="margin: 0 0 10px 0; color: #F56C6C; font-size: 18px;">📆 方案二：按月一口价</h3>
                <p style="margin: 8px 0;"><strong>计费月数：</strong>${this.months}个月（不足一月按一月计算）</p>
                
                <p style="margin: 8px 0;"><strong>月单价：</strong>${this.monthPrice}元/月</p>
                ${this.isShow3 ? `<p style="margin: 8px 0; color: #E6A23C;"><strong>封顶说明：</strong>月费用300元封顶</p>` : ''}
                <p style="margin: 15px 0 5px 0; font-size: 22px; font-weight: bold; color: #F56C6C; text-align: center; padding: 10px; background-color: white; border-radius: 5px;">
                    💰 最终价格：<span style="background-color: hsla(55, 89%, 50%, 0.903); padding: 5px 15px; border-radius: 3px;">${this.monthTotalPrice}元</span>
                </p>
            `;
            
            monthPriceSection.innerHTML = monthPriceDetail;
            quotationContent.appendChild(monthPriceSection);

            // 添加温馨提示
            if (user_identity === 'user') {
                const tipsSection = document.createElement('div');
                tipsSection.style.marginTop = '20px';
                tipsSection.style.padding = '10px';
                tipsSection.style.backgroundColor = '#fdf6ec';
                tipsSection.style.borderRadius = '5px';
                tipsSection.style.borderLeft = '4px solid #E6A23C';
                tipsSection.innerHTML = `
                    <p style="margin: 5px 0; color: #E6A23C; font-size: 14px;"><strong>💡 温馨提示：</strong></p>
                    <p style="margin: 5px 0; font-size: 13px; color: #666;">• 以上两种方案可任选其一</p>
                    <p style="margin: 5px 0; font-size: 13px; color: #666;">• 只有选择按天算，提前取行李才会退多余费用</p>
                    <p style="margin: 5px 0; font-size: 13px; color: #666;">• 如有疑问，欢迎咨询客服</p>
                `;
                quotationContent.appendChild(tipsSection);
            }

            // 添加联系方式
            if (user_identity === 'user') {
                const contactInfo = document.createElement('div');
                contactInfo.style.marginTop = '20px';
                contactInfo.style.padding = '15px';
                contactInfo.style.backgroundColor = '#fff';
                contactInfo.style.borderRadius = '8px';
                contactInfo.style.border = '2px solid #F56C6C';
                contactInfo.innerHTML = `
                    <h3 style="margin: 0 0 10px 0; color: #F56C6C; font-size: 18px;">📞 联系方式</h3>
                    <p style="margin: 8px 0; font-size: 16px;"><strong>微信：</strong><span style="color: #F56C6C; font-weight: bold; font-size: 18px;">hszt214</span></p>
                    <p style="margin: 10px 0 0 0; padding-top: 10px; border-top: 1px dashed #ddd; color: #909399; font-size: 14px;">
                        说明：如接受此报价，请直接微信联系我
                    </p>
                `;
                quotationContent.appendChild(contactInfo);
            }

            // 将报价单添加到页面
            document.body.appendChild(quotationContent);

            // 使用html2canvas生成图片
            html2canvas(quotationContent, {
                scale: 2,
                backgroundColor: 'white'
            }).then(canvas => {
                const imgData = canvas.toDataURL('image/png');

                // if (this.isWechatBrowser) {
                //     // 在微信中显示预览
                //     this.previewImage = imgData;
                //     this.showPreview = true;
                //     this.$message({
                //         message: '由于微信限制，请长按图片保存或使用浏览器打开下载',
                //         type: 'warning',
                //         duration: 5000
                //     });
                // } else {
                //     // 在浏览器中直接下载
                //     const link = document.createElement('a');
                //     link.href = imgData;
                //     link.download = `行李寄存报价单_${this.form.startDate}_${this.form.endDate}.png`;
                //     link.click();
                // }

                // 20250618更新，统一都弹窗显示
                this.previewImage = imgData;
                this.showPreview = true;

                // 移除临时创建的报价单元素
                document.body.removeChild(quotationContent);
            });
        }
    }
}
</script>

<style>
#app {
    font-family: 'Microsoft YaHei', Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    margin: 10px;
    padding: 0;
}

.el-header {
    text-align: center;
    background-color: #409EFF;
    color: white;
    padding: 0;
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.header-content {
    padding: 10px 0;
}

.header-content h1 {
    font-size: 24px;
    margin: 0;
    line-height: 1.5;
}

.header-content p {
    margin: 5px 0 0;
    font-size: 14px;
    line-height: 1.5;
}

.el-main {
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    padding: 10px;
    box-sizing: border-box;
}

.el-container {
    width: 100%;
    max-width: 100%;
    margin: 0;
    padding: 0;
}

/* 导航菜单样式 */
.nav-menu {
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    position: sticky;
    top: 0;
    z-index: 100;
}

.nav-menu .el-menu {
    border-bottom: none;
    max-width: 800px;
    margin: 0 auto;
}

.price-rules,
.calculator,
.contact {
    margin-bottom: 15px;
}

.price-result {
    margin-top: 15px;
    padding: 15px;
    background-color: #f5f7fa;
    border-radius: 4px;
}

.total {
    font-size: 18px;
    font-weight: bold;
    color: #409EFF;
}

.contact {
    background-color: #f5f7fa;
}

.discount-info {
    margin-top: 15px;
    padding: 10px;
    background-color: #f0f9eb;
    border-radius: 4px;
    color: #67c23a;
    font-weight: bold;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
    #app {
        margin: 5px;
    }

    .el-header {
        line-height: 50px;
    }

    .el-header h1 {
        font-size: 20px;
    }

    /* 导航菜单移动端适配 */
    .nav-menu .el-menu {
        display: flex;
        justify-content: space-around;
    }

    .nav-menu .el-menu-item {
        flex: 1;
        text-align: center;
        padding: 0 10px !important;
        font-size: 14px;
    }

    .el-main {
        max-width: 100%;
        padding: 5px;
    }

    .el-form-item {
        margin-bottom: 15px;
    }

    .el-form-item__label {
        font-size: 14px;
        line-height: 1.5;
        padding: 0 0 5px;
    }

    .el-input-number {
        width: 100%;
    }

    .el-select {
        width: 100%;
    }

    .el-date-editor.el-input {
        width: 100% !important;
    }

    .el-date-editor--daterange {
        width: 100% !important;
    }

    .el-date-editor .el-range-separator {
        padding: 0 5px;
    }

    .el-date-editor .el-range-input {
        width: 40%;
    }

    .el-table {
        font-size: 12px;
    }

    .el-table th {
        padding: 8px 0;
    }

    .el-table td {
        padding: 6px 0;
    }

    .price-result {
        padding: 10px;
    }

    .price-result p {
        margin: 5px 0;
        font-size: 14px;
    }

    .total {
        font-size: 16px;
    }

    .discount-info {
        font-size: 14px;
        padding: 8px;
    }

    .contact p {
        margin: 5px 0;
        font-size: 14px;
    }

    /* 调整表单项布局 */
    .el-form-item__content {
        margin-left: 0 !important;
    }

    /* 调整按钮宽度 */
    .el-button {
        width: 100%;
    }
}

.luggage-item {
    border: 1px solid #EBEEF5;
    border-radius: 4px;
    padding: 15px;
    margin-bottom: 20px;
    background-color: #f8f8f8;
}

.item-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 1px solid #EBEEF5;
    min-width: 200px;
}

.item-header span {
    font-size: 16px;
    font-weight: bold;
    color: #409EFF;
    white-space: nowrap;
    margin-right: 20px;
}

.item-header .el-button {
    flex-shrink: 0;
}

.preview-dialog {
    max-width: 600px;
    margin: 0 auto;
}

.preview-dialog .el-dialog__body {
    padding: 10px;
}

.preview-container {
    text-align: center;
    background: #f5f7fa;
    padding: 10px;
    border-radius: 4px;
}

.preview-container img {
    max-width: 100%;
    height: auto;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

@media screen and (max-width: 768px) {
    .preview-dialog {
        width: 95% !important;
        margin: 10px auto;
    }
}

/* 修改表单项样式 */
.el-form-item {
    display: flex;
    align-items: center;
    margin-bottom: 22px;
}

.el-form-item__label {
    line-height: 32px !important;
    padding-right: 12px;
    text-align: right;
    justify-content: flex-end;
    display: flex;
}

.el-form-item__content {
    display: flex;
    align-items: center;
    line-height: 32px;
    position: relative;
    font-size: 14px;
}

/* 统一输入组件宽度 */
.el-input-number,
.el-select,
.el-date-editor.el-input {
    width: 170px !important;
}

.el-input-number .el-input__inner {
    text-align: left;
}

.el-switch {
    margin-top: 0;
}

.luggage-item {
    border: 1px solid #EBEEF5;
    border-radius: 4px;
    padding: 15px;
    margin-bottom: 20px;
    background-color: #f8f8f8;
}

.luggage-item .el-form-item {
    margin-bottom: 15px;
}

.luggage-item .el-form-item:last-child {
    margin-bottom: 0;
}

.luggage-item .el-form-item__label {
    width: 90px;
    text-align: right;
    justify-content: flex-end;
}

.luggage-item .el-input-number,
.luggage-item .el-select {
    width: 170px !important;
}

@media screen and (max-width: 768px) {

    .el-input-number,
    .el-select,
    .el-date-editor.el-input,
    .luggage-item .el-input-number,
    .luggage-item .el-select {
        width: 100% !important;
    }
}
</style>